var map = {
	"./badge_color_adv-ccr.svg": "2a87",
	"./badge_color_adv-supports.svg": "ac91",
	"./badge_color_cap-academicplan.svg": "f14b",
	"./badge_color_cap-careerplan.svg": "6c73",
	"./badge_color_cap-experience.svg": "d548",
	"./badge_color_cap-exploration.svg": "4b72",
	"./badge_color_cap-foundation.svg": "12b7",
	"./badge_color_fia-application.svg": "cdff",
	"./badge_color_fia-cost.svg": "0936",
	"./badge_color_fia-foundation.svg": "0462",
	"./badge_color_fia-scholarship.svg": "32cf",
	"./badge_color_highered-finance.svg": "5704",
	"./badge_color_highered-holistic.svg": "ccd7",
	"./badge_color_holistic-finance.svg": "74f9",
	"./badge_color_holistic-holistic.svg": "24d2",
	"./badge_color_hs-academic.svg": "5cb4",
	"./badge_color_hs-career.svg": "5406",
	"./badge_color_hs-college.svg": "483e",
	"./badge_color_hs-finaid.svg": "62cc",
	"./badge_color_hs-military.svg": "7840",
	"./badge_color_ihe-finance.svg": "6aa2",
	"./badge_color_ihe-holistic.svg": "3700",
	"./badge_color_ms-academic.svg": "8ae5",
	"./badge_color_ms-career.svg": "7565",
	"./badge_color_ms-finaid.svg": "46b1",
	"./badge_color_pop-admission.svg": "014b",
	"./badge_color_pop-entrance.svg": "795c",
	"./badge_color_pop-foundation.svg": "25b0",
	"./badge_color_pop-research.svg": "aa2b",
	"./badge_color_she-finance.svg": "a352",
	"./badge_color_she-holistic.svg": "39cf",
	"./badge_color_spe-beta-v2.svg": "8204",
	"./badge_color_spe-beta.svg": "a8d9",
	"./badge_color_spe-middle.svg": "5cf7",
	"./badge_color_spe-middle0001.svg": "873a",
	"./badge_color_spe-mobile.svg": "8519",
	"./badge_color_spe-transition.svg": "5b3a",
	"./badge_color_txcan-finaid.svg": "5327",
	"./badge_gray_adv-ccr.svg": "26ab",
	"./badge_gray_adv-supports.svg": "af20",
	"./badge_gray_cap-academicplan.svg": "544c",
	"./badge_gray_cap-careerplan.svg": "79af",
	"./badge_gray_cap-experience.svg": "c577",
	"./badge_gray_cap-exploration.svg": "d64b",
	"./badge_gray_cap-foundation.svg": "3486",
	"./badge_gray_fia-application.svg": "d5df",
	"./badge_gray_fia-cost.svg": "eea5",
	"./badge_gray_fia-foundation.svg": "3a7d",
	"./badge_gray_fia-scholarship.svg": "d435",
	"./badge_gray_highered-finance.svg": "8055",
	"./badge_gray_highered-holistic.svg": "5c41",
	"./badge_gray_holistic-finance.svg": "f278",
	"./badge_gray_holistic-holistic.svg": "4a9d",
	"./badge_gray_hs-academic.svg": "194c",
	"./badge_gray_hs-career.svg": "6e68",
	"./badge_gray_hs-college.svg": "b128",
	"./badge_gray_hs-finaid.svg": "d1f2",
	"./badge_gray_hs-military.svg": "496c",
	"./badge_gray_ihe-finance.svg": "853f",
	"./badge_gray_ihe-holistic.svg": "56c6",
	"./badge_gray_ms-academic.svg": "5ef1",
	"./badge_gray_ms-career.svg": "03bb",
	"./badge_gray_ms-finaid.svg": "c3d3",
	"./badge_gray_pop-admission.svg": "50d5",
	"./badge_gray_pop-entrance.svg": "b4d7",
	"./badge_gray_pop-foundation.svg": "531b",
	"./badge_gray_pop-research.svg": "bfa4",
	"./badge_gray_she-finance.svg": "2f65",
	"./badge_gray_she-holistic.svg": "e741",
	"./badge_gray_spe-beta-v2.svg": "afe1",
	"./badge_gray_spe-beta.svg": "e6c5",
	"./badge_gray_spe-middle.svg": "e92b",
	"./badge_gray_spe-middle0001.svg": "dd77",
	"./badge_gray_spe-mobile.svg": "580d",
	"./badge_gray_spe-transition.svg": "a6c4",
	"./badge_gray_txcan-finaid.svg": "10e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "df25";